module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/sprite-main/drop-4624993c997f9acbcd474e076f6f2715.svg";